import React, { ReactNode } from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier } from '../../../lib/bemUtils/Modifier';

const termClass = 'definition-list__term font-bold-13-13';
const descriptionClass = 'definition-list__description';
const listClass = 'definition-list';

export enum DefinitionListModifier {
  INLINE_NO_BOLD = 'inline-no-bold',
  MULTIPLE = 'multiple',
}
/**
 * Creates a DefinitionTerm Object with default classes.
 */
export const createDefinitionTerm = (term: string, description: string) => ({
  term,
  class: termClass,
  definitionDescriptions: [{ description, class: descriptionClass }],
});

/**
 * Creates a DefinitionList with default class.
 * Use this for more flexibility.
 */
export function DL({ children, modifier }: { children: ReactNode; modifier?: Modifier<DefinitionListModifier> }) {
  return <dl className={bem(listClass, modifier)}>{children}</dl>;
}

/**
 * Creates a DefinitionDescription with default class.
 * Use this for more flexibility
 */
export function DT({ children }: { children: ReactNode }) {
  return <dt className={termClass}>{children}</dt>;
}

/**
 * Creates a DefinitionTerm with default class.
 * Use this for more flexibility
 */
type DDProps = {
  children: ReactNode;
  modifier?: Modifier<DefinitionListModifier>;
};

export function DD({ children, modifier }: DDProps) {
  return <dd className={bem(descriptionClass, modifier)}>{children}</dd>;
}
